import req from "../request";
import animate from "./animate";
export function safeGet(obj, attr) {
  const arr = attr.split(".");
  let first = arr.shift();
  let tmp = obj[first];
  while (arr.length) {
    first = arr.shift();
    tmp = tmp[first];
  }
  return tmp;
}

export function getAuthUrl() {
  const url = new URL(window.location.href);
  const code = url.searchParams.get("code");
  const jid = url.searchParams.get("jid");
  const path = url.searchParams.get("path");
  const code_type = url.searchParams.get("code_type");
  const jd_top = url.searchParams.get("jd_top");
  var data = {redirectUrl: url.origin};
  if(code)data.code = code;
  if(jid)data.jid = jid;
  if(path)data.path = path;
  if(code_type)data.code_type = code_type;
  if(jd_top)data.jd_top = jd_top;
  return req.post("/wx/authUrl", data);
}

export function scrollTo(pos) {
  const old = document.documentElement.scrollTop;
  const d = pos - old;
  animate(
    300,
    (p) => {
      window.scrollTo(0, old + d * p);
    },
    animate.sinIn
  );
}
